import axiosDeqart from '../axios';

const generateQuantumJob = async (quantumJobBody) => {
  const { data } = await axiosDeqart.post('/jobs', quantumJobBody);
  return data?.data;
};

export default generateQuantumJob;
